import { Button, ButtonProps } from "antd";
import { CSSProp } from "styled-components";

import { ButtonCustomStyle } from "./ButtonCustom.style";

export interface ButtonCustomStyleProps extends ButtonProps {
  background_color?: string;
  color?: string;
  border_color?: string;
  width?: number;
  hover_style?: CSSProp;
}

const ButtonCustom = (props: ButtonCustomStyleProps) => {
  const { background_color, color, border_color, width, hover_style } = props;

  return (
    <ButtonCustomStyle
      background_color={background_color}
      color={color}
      border_color={border_color}
      width={width}
      hover_style={hover_style}
    >
      <Button {...props} />
    </ButtonCustomStyle>
  );
};

export default ButtonCustom;
